// @src: https://markus.oberlehner.net/blog/how-to-structure-a-complex-vuex-store/
// @src https://medium.com/swlh/adding-modules-to-a-vuex-store-8afead95e5af
// @src https://vueschool.io/lessons/vuex-modules
import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules
})

// console.log(store)

// Automatically run the init action for every module if one exists
for (const moduleName of Object.keys(modules)) {
  // console.log('\nmoduleName =', moduleName)
  // console.log('modules[moduleName].actions =', modules[moduleName].actions)
  if (modules[moduleName].actions.init) {
    store.dispatch(`${moduleName}/init`)
  }
}

export default store
